import React,{useEffect,useState} from 'react'
import AdminDashboard from "../../components/AdminDashboard"
import StatsBox from "../../components/StatsBox"
import icon1 from "../../components/assets/statstwousers.png"
import icon2 from "../../components/assets/statstrade.png"
import icon3 from "../../components/assets/statsuser.png"
import icon4 from "../../components/assets/statsconfirm.png"
import icon5 from "../../components/assets/statsmessage.png"
import icon6 from "../../components/assets/statsbabe.png"
import axios from "axios"
// import { useSnackbar } from "notistack"

const url = "https://www.bitmasta.io/php/admin_pass.php";
export default function AdminHome(props) {
    const [stats,setStats] = useState("")
    useEffect(()=>{
    const fetchStats =()=>{
        const formData = new FormData()
        formData.append("Stats",true)
        try{ 
            axios.post(url,formData).then(res=>{
                setStats(res.data)
            })
        }
        catch(err) {
            console.log(err);
        }
    }
    fetchStats()
    },[])
    return (
        <AdminDashboard {...props}>
        <div className="row">
            <StatsBox number={stats ? stats.Registered_Users_Count:"..."} icon={icon1} title="Total of User registered"/>
            <StatsBox number={stats ? stats.Transactions_Count:"..."} icon={icon2} title="Total Transactions"/>
            <StatsBox number={stats ? stats.Guests_Count:"..."} icon={icon3} title="Guest"/>
            <StatsBox number={stats ? stats.Transactions_Completed_Count:"..."} icon={icon4} title="Completed Trans"/>
            <StatsBox number={stats ? "0":"..."} icon={icon5} title="Uncompleted Trans"/>
            <StatsBox number={stats ? stats.Transactions_Pending_Count:"..."} icon={icon6} title="Pending Trans"/>
        </div>
        </AdminDashboard>
    )
}
